"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPreviousCurrentNext = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var lots_for_auction_1 = require("../../../../../api/calls/lot/v3/lots_for_auction");
var manual_current_lot_1 = require("../../../../../api/calls/lot/v3/manual_current_lot");
var main_1 = require("../../../../../reducers/slices/main");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var manual_set_current_1 = require("../../../../../api/calls/lot/v3/manual_set_current");
var socket_1 = require("../../../../../socket");
var manual_lot_status_1 = require("../../../../../api/calls/lot/v3/manual_lot_status");
var update_lot_status_1 = require("../../../../../api/calls/lot/v3/update_lot_status");
var AdminPreviousCurrentNext = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var currentLotChanged = props.currentLotChanged;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _g = (0, react_1.useState)(null), pcn = _g[0], setPcn = _g[1];
    //   console.log(pcn, "pcn");
    var mainAuction = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).mainAuction;
    (0, react_1.useEffect)(function () {
        if (mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.entity_id) {
            socket_1.socket.off("currentLot");
            socket_1.socket.on("currentLot", function (data) {
                getPCN();
            });
            getPCN();
        }
    }, [mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.entity_id]);
    (0, react_1.useEffect)(function () {
        if (mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.entity_id) {
            (0, lots_for_auction_1.lots_for_auction)({
                auction_entity_id: mainAuction.entity_id,
            }).then(function (response) {
                //         console.log("response", response);
                // setLots(response.data.content);
            });
        }
    }, [mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.entity_id]);
    function getPCN() {
        (0, manual_current_lot_1.manual_previous_current_next)({
            auction_entity_id: mainAuction.entity_id,
        }).then(function (response) {
            var _a;
            //       console.log(response,"responseresponse")
            if (response.data.success) {
                setPcn(response.data.content);
                currentLotChanged((_a = response.data.content) === null || _a === void 0 ? void 0 : _a.current);
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Error",
                    messages: [response.data.message],
                }));
            }
        });
    }
    function manualSetCurrent(lot_entity_id) {
        if (lot_entity_id) {
            (0, manual_set_current_1.manual_set_current)({
                auction_entity_id: mainAuction.entity_id,
                lot_entity_id: lot_entity_id,
            }).then(function (response) {
                if (response.data.success) {
                    //
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Error",
                        messages: [response.data.message],
                    }));
                }
            });
        }
    }
    function manualLotStatusReserve(lot_entity_id, status) {
        var payload = {
            lot_id: lot_entity_id,
            other_details: {
                reserve_price: status,
            },
        };
        (0, update_lot_status_1.update_lot_status)(payload).then(function (response) {
            if (response.data.success) {
                if (pcn.next) {
                    manualSetCurrent(pcn.next.entity_id);
                }
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Error",
                    messages: [response.data.message],
                }));
            }
        });
    }
    function manualLotStatus(lot_entity_id, status) {
        (0, manual_lot_status_1.manual_lot_status)({
            entity_id: lot_entity_id,
            status: status,
        }).then(function (response) {
            if (response.data.success) {
                if (pcn.next) {
                    manualSetCurrent(pcn.next.entity_id);
                }
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Error",
                    messages: [response.data.message],
                }));
            }
        });
    }
    return pcn ? (react_1.default.createElement("div", { className: "W-full h-full flex items-stretch rounded-xl border-4 border-[#458CF2] " },
        react_1.default.createElement("div", { className: "w-1/4" },
            react_1.default.createElement("div", { className: "w-full flex flex-col h-full" },
                react_1.default.createElement("div", { className: "w-full py-2.5  bg-[#458CF2]" },
                    react_1.default.createElement("p", { className: "uppercase text-white text-[22px] font-semibold text-center" }, "Previous")),
                react_1.default.createElement("div", { className: "w-full h-full" }, pcn.previous ? (react_1.default.createElement("div", { className: "w-full flex items-center flex-wrap" },
                    react_1.default.createElement("div", { className: "w-full " },
                        react_1.default.createElement("img", { src: (_b = (_a = pcn === null || pcn === void 0 ? void 0 : pcn.previous.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.uploaded_file_url, alt: "previous_lot_image", className: "w-full h-64 object-cover" })),
                    react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-4 p-4" },
                        react_1.default.createElement("div", { className: "w-full text-center" },
                            react_1.default.createElement("div", { className: "w-full flex items-center justify-center" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faHashtag }),
                                react_1.default.createElement("span", { className: "font-bold text-md" }, pcn.previous.lot_number))),
                        react_1.default.createElement("div", { className: "w-full text-center" },
                            react_1.default.createElement("p", { className: "text-lg font-bold text-center" }, pcn.previous.title))))) : (react_1.default.createElement("div", { className: "flex-1 flex items-center justify-center h-full bg-red-300 rounded-bl-lg" }, "No Previous Lot"))))),
        react_1.default.createElement("div", { className: "w-2/4" },
            react_1.default.createElement("div", { className: "w-full flex flex-col h-full" },
                react_1.default.createElement("div", { className: "w-full py-2.5  bg-[#458CF2]" },
                    react_1.default.createElement("p", { className: "uppercase text-white text-[22px] font-semibold text-center" }, "Current")),
                react_1.default.createElement("div", { className: "w-full h-full" }, (pcn === null || pcn === void 0 ? void 0 : pcn.current) ? (react_1.default.createElement("div", { className: "border-l-4 border-r-4 border-l-red-500 border-r-green-500 w-full h-full" },
                    react_1.default.createElement("div", { className: "w-full " },
                        react_1.default.createElement("img", { src: (_d = (_c = pcn === null || pcn === void 0 ? void 0 : pcn.current.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.uploaded_file_url, alt: "previous_lot_image", className: "w-full h-64 object-cover" })),
                    react_1.default.createElement("div", { className: "w-full p-2 h-auto flex flex-col gap-y-4" },
                        react_1.default.createElement("div", { className: "w-full text-center" },
                            react_1.default.createElement("div", { className: "w-full flex items-center justify-center" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faHashtag }),
                                react_1.default.createElement("span", { className: "font-bold text-md" }, pcn === null || pcn === void 0 ? void 0 : pcn.current.lot_number))),
                        react_1.default.createElement("div", { className: "w-full text-center" },
                            react_1.default.createElement("p", { className: "text-lg font-bold text-center" }, pcn === null || pcn === void 0 ? void 0 : pcn.current.title)),
                        react_1.default.createElement("div", { className: "w-full flex items-center justify-center flex-wrap gap-y-4" },
                            react_1.default.createElement("div", { className: "w-auto px-2 uppercase cursor-pointer" },
                                react_1.default.createElement("div", { className: "w-auto flex items-center justify-center px-3 py-2.5 rounded-[5px] bg-[#458CF2] transition-all duration-100 ease-in-out hover:bg-black" },
                                    react_1.default.createElement("span", { className: "text-sm text-semibold text-white", onClick: function () { return manualLotStatus(pcn === null || pcn === void 0 ? void 0 : pcn.current.entity_id, "Sold"); } }, "SOLD"))),
                            react_1.default.createElement("div", { className: "w-auto px-2 uppercase cursor-pointer" },
                                react_1.default.createElement("div", { className: "w-auto flex items-center justify-center px-3 py-2.5 rounded-[5px] bg-[#458CF2] transition-all duration-100 ease-in-out hover:bg-black" },
                                    react_1.default.createElement("span", { className: "text-sm text-semibold text-white", onClick: function () { return manualLotStatus(pcn === null || pcn === void 0 ? void 0 : pcn.current.entity_id, "Subject to Confirm"); } }, "STC"))),
                            react_1.default.createElement("div", { className: "w-auto px-2 uppercase cursor-pointer" },
                                react_1.default.createElement("div", { className: "w-auto flex items-center justify-center px-3 py-2.5 rounded-[5px] bg-[#458CF2] transition-all duration-100 ease-in-out hover:bg-black" },
                                    react_1.default.createElement("span", { className: "text-sm text-semibold text-white uppercase", onClick: function () { return manualLotStatus(pcn === null || pcn === void 0 ? void 0 : pcn.current.entity_id, "Withdrawn"); } }, "Wthdraw"))),
                            react_1.default.createElement("div", { className: "w-auto px-2 uppercase cursor-pointer" },
                                react_1.default.createElement("div", { className: "w-auto flex items-center justify-center px-3 py-2.5 rounded-[5px] bg-[#458CF2] border transition-all duration-100 ease-in-out hover:bg-black" },
                                    react_1.default.createElement("span", { className: "text-sm text-semibold text-white uppercase", onClick: function () { return manualLotStatus(pcn === null || pcn === void 0 ? void 0 : pcn.current.entity_id, "Reserve Not reached"); } }, "Reserve Not reached"))),
                            react_1.default.createElement("div", { className: "w-auto px-2 uppercase cursor-pointer" },
                                react_1.default.createElement("div", { className: "w-auto flex items-center justify-center px-3 py-2.5 rounded-[5px] bg-[#458CF2] border transition-all duration-100 ease-in-out hover:bg-black" },
                                    react_1.default.createElement("span", { className: "text-sm text-semibold text-white uppercase", onClick: function () { return manualLotStatusReserve(pcn === null || pcn === void 0 ? void 0 : pcn.current.entity_id, null); } }, "No Reserve"))))))) :
                    (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "w-full h-full flex items-center justify-center" },
                            react_1.default.createElement("p", null, "No Current Lot"))))))),
        react_1.default.createElement("div", { className: "w-1/4" },
            react_1.default.createElement("div", { className: "w-full flex flex-col h-full" },
                react_1.default.createElement("div", { className: "w-full py-2.5 bg-[#458CF2]" },
                    react_1.default.createElement("p", { className: "uppercase text-white text-[22px] font-semibold text-center" }, "Next")),
                react_1.default.createElement("div", { className: "w-full h-full" }, pcn.next ? (react_1.default.createElement("div", { className: "w-full flex items-center flex-wrap" },
                    react_1.default.createElement("div", { className: "w-full " },
                        react_1.default.createElement("img", { src: (_f = (_e = pcn === null || pcn === void 0 ? void 0 : pcn.next.images) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.uploaded_file_url, alt: "previous_lot_image", className: "w-full h-64 object-cover" })),
                    react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-4 p-4" },
                        react_1.default.createElement("div", { className: "w-full text-center" },
                            react_1.default.createElement("div", { className: "w-full flex items-center justify-center" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faHashtag }),
                                react_1.default.createElement("span", { className: "font-bold text-md" }, pcn.next.lot_number))),
                        react_1.default.createElement("div", { className: "w-full text-center" },
                            react_1.default.createElement("p", { className: "text-lg font-bold text-center" }, pcn.next.title))))) : (react_1.default.createElement("div", { className: "flex-1 h-full flex items-center justify-center bg-red-300 rounded-br-[20px]" }, "No Next Lot")))))))
        :
            (react_1.default.createElement("div", { className: "grid grid-cols-3" }, "No PCN detected."));
};
exports.AdminPreviousCurrentNext = AdminPreviousCurrentNext;
